import { makeStyles } from '@material-ui/core/styles';

export const scopesReportsStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  }
}));
